var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNftsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5083 1.84163C10.2083 1.60829 9.79168 1.60829 9.49168 1.84163C7.90834 3.04996 3.23331 6.99163 3.25831 11.5833C3.25831 15.3 6.28334 18.3333 10.0083 18.3333C13.7333 18.3333 16.7583 15.3083 16.7583 11.5916C16.7667 7.06663 12.0833 3.05829 10.5083 1.84163Z",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66663V18.3333",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15.7999L16.4167 12.6832",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.6334L16.1417 8.65002",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7.46659L14.1917 5.42493",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftsIcon);
export default __webpack_public_path__ + "static/media/nfts-icon.270d4fa4acee92893eefde41d2a810c2.svg";
export { ForwardRef as ReactComponent };